export var GoodsStatus;

(function (GoodsStatus) {
  GoodsStatus["OFF_SHELVES"] = "OFF_SHELVES";
  GoodsStatus["ON_SHELVES"] = "ON_SHELVES";
})(GoodsStatus || (GoodsStatus = {}));

export var GoodsOrderBy = {
  updatedAt: 'UPDATED_AT',
  isbn: 'ISBN',
  publishedDate: 'PUBLISHED_DATE',
  subTitle: 'SUB_TITLE',
  title: 'TITLE',
  author: 'AUTHOR',
  press: 'PRESS',
  status: 'STATUS',
  price: 'PRICE',
  createdAt: 'CREATED_AT',
  'managers.createdBy.id': 'CREATOR_ID',
  'managers.modifiedBy.id': 'MODIFIER_ID'
};